interface AnyObject {
    [key: string]: string | number | AnyObject | null
}

export function setObjectValuesToNull(obj: AnyObject): void {
    if (typeof obj === "object" && obj !== null) {
        for (let key in obj) {
            if (typeof obj[key] === "string" || typeof obj[key] === "number") {
                obj[key] = null
            } else {
                setObjectValuesToNull(obj[key] as AnyObject)
            }
        }
    }
}

export const findSelectionValue = (name: string, v: any): string | number => {
    let foundValue = null
    for (var property in v) {
        if (!foundValue) {
            if (property === name) {
                return v[property]
            } else if (typeof v[property] === "object") {
                foundValue = findSelectionValue(name, v[property])
            }
        }
    }

    return foundValue
}

export const getChoiceTitleById = (id: string | number, choices: OfferAssistantChoice[]) => {
    for (let choice in choices) {
        if (choices[choice].id === id) {
            return choices[choice].title
        }
    }
    return null
}

export const prepareSelectionsForDealers = (config: OfferAssistantField[], value: any) => {
    let selectionInformationForDealers = ""
    for (var propertyName in config) {
        if (!config.hasOwnProperty(propertyName)) continue
        const field = config[propertyName]
        if (field.subFields && field.subFields.length) {
            selectionInformationForDealers += prepareSelectionsForDealers(field.subFields, value)
            continue
        }

        // Find selected value of an element
        const selectedValue = findSelectionValue(field.name, value)
        if (!selectedValue) continue
        // Output - Label
        selectionInformationForDealers += field.label + "<br/>"
        if (!field.choices) {
            // Output - Radio or Input Value
            selectionInformationForDealers += `> ${selectedValue} <br/><br/>`
        } else {
            if (Array.isArray(selectedValue)) {
                // Output - Multiple Choices Selection
                for (let i = 0; i < selectedValue.length; i++) {
                    const content = getChoiceTitleById(selectedValue[i], field.choices)
                    selectionInformationForDealers += `> ${content} <br/>`
                }
                selectionInformationForDealers += `<br/>`
            } else {
                // Output - Choices Selection
                const content = getChoiceTitleById(selectedValue, field.choices)
                selectionInformationForDealers += `> ${content} <br/><br/>`
            }
        }
    }
    return selectionInformationForDealers
}
export const normalizeValueObject = (
    obj: any,
    normalizedConfiguration: {
        configuration: ConfigOption[]
    }
) => {
    for (var propertyName in obj) {
        if (!obj.hasOwnProperty(propertyName)) continue
        if (Array.isArray(obj[propertyName])) {
            normalizedConfiguration.configuration.push({
                cfgOpt: {
                    cfgOptName: propertyName,
                    cfgOptValue: obj[propertyName]?.join(";"),
                },
            })
        } else if (typeof obj[propertyName] === "object") {
            normalizeValueObject(obj[propertyName], normalizedConfiguration)
        } else {
            if (!obj[propertyName]) continue
            normalizedConfiguration.configuration.push({
                cfgOpt: {
                    cfgOptName: propertyName,
                    cfgOptValue: obj[propertyName],
                },
            })
        }
    }
}
